import type { MentionMap } from '@atlassian/ai-model-io/utils/mention-map';

import type {
	UpdateIdMap,
	EditorPluginAIConfigItem,
} from '../../prebuilt/config-items/config-items';
import { isTargetingNewConvoAIEndpoint } from '../../prebuilt/utils';

import { getRequestOptions4AssistanceService } from './request-options-assistance-service';
import { getRequestOptions4ConvoAI } from './request-options-convo-ai';
import { getRequestOptions4RovoChat } from './request-options-rovo-agent';
import type { AIExperienceMachineContextForRequest, RequestOptions, ResponseObject } from './types';

export function getRequestOptions({
	callback,
	context,
	configItem,
	mentionMap,
}: {
	callback: (event: ResponseObject) => void;
	context: AIExperienceMachineContextForRequest;
	configItem: EditorPluginAIConfigItem;
	mentionMap?: MentionMap;
}): RequestOptions {
	// elevate free generate is disabled and returns the pre-configured response immediately
	if (configItem.response) {
		return { response: configItem.response };
	}

	const updateIdMap: UpdateIdMap = ({ idMap }) => {
		callback({
			type: 'update idMap',
			context: {
				idMap,
			},
		});
	};

	let requestOptions: RequestOptions;

	if (configItem.agent) {
		requestOptions = getRequestOptions4RovoChat({
			context,
			configItem,
			mentionMap,
			updateIdMap,
		});
	} else {
		if (isTargetingNewConvoAIEndpoint(configItem.featureId)) {
			requestOptions = getRequestOptions4ConvoAI({
				context,
				configItem,
				mentionMap,
				updateIdMap,
				callback,
			});
		} else {
			requestOptions = getRequestOptions4AssistanceService({
				context,
				configItem,
				mentionMap,
				updateIdMap,
			});
		}
	}

	if ('contentStatistics' in requestOptions && requestOptions.contentStatistics) {
		callback({
			type: 'storeContextStatistics',
			contextStatistics: { inputDocument: requestOptions.contentStatistics },
		});
	}

	return requestOptions;
}
